// import api from './api'


const calculateProgressFromCompletedCheckpoints = (moduleMeta, completedCheckpointIds) => {
  if (moduleMeta.navigationType === 'linear' && completedCheckpointIds.includes('complete')) return 100
  let progress = 0
  for (const checkpoint of completedCheckpointIds) {
    const topic = moduleMeta.topics.find(topic => topic.id === checkpoint)
    if (topic) {
      progress += topic.completion
    }
  }
  return progress
}

export default {
  calculateProgressFromSession: (moduleMeta, session) => {
    if (!session.state || !moduleMeta) {
      return 0
    }
    const checkpoints = JSON.parse(session.state).passedCheckpoints
    
    // Extract all checkpoints that have completed
    const completedCheckpointsIds = checkpoints.filter(checkpoint => checkpoint.complete.toString() === 'true' || checkpoint.id === 'complete').map(x => x.id)
    // console.dir(completedCheckpointsIds)
    return calculateProgressFromCompletedCheckpoints(moduleMeta, completedCheckpointsIds)
  },

  calculateProgressFromClassLearner: (moduleMeta, classLearnerProgress) => {
    if (!classLearnerProgress || !moduleMeta) {
      return 0
    }
    
    
    const moduleProgress = classLearnerProgress[moduleMeta.id]
    if (!moduleProgress) {
      return 0
    }
    const completedCheckpointsIds = Object.keys(moduleProgress)
    return calculateProgressFromCompletedCheckpoints(moduleMeta, completedCheckpointsIds)
  },
}
